import { select } from "@angular-redux/store";
import { Component, OnDestroy, OnInit } from "@angular/core";
//import TelemetryEvent from "msal/lib-commonjs/telemetry/TelemetryEvent";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs"; 
import { ApplicationUserService } from "../../../pb-screen/services/application.user.service";
import { ApplicationUser,  UserSettings } from "../../../pb-screen/models/application.user.interface";
import { UserActions, UserAuthorization } from "../../models/user-authorization.interface";

import { ModalType } from "../../../shared/models/component-source";
import { SharedActions } from "../../../shared/shared.actions";
import { defaultDepotInPlanningBlockColumnDefinition } from "../../../static/depotInPlanningBlockColumnDefinition";
import { defaultDepotOutPlanningBlockColumnDefinition } from "../../../static/depotOutPlanningBlockColumnDefinition";
import { forEach } from "@angular/router/src/utils/collection";
import { UserSettingsService } from "../../../pb-screen/services/usersettings.service";
import { UserSetting } from "../../../shared/models/usersettings/user-setting.interface";
import {  ApplicationUserActions } from "../../../pb-screen/application.user.actions";
import { SimpleModalComponent } from "ngx-simple-modal";
import { ModalManagerService } from "../../../shared/services/modal-manager.service";
import { ApplicationScreens } from "../../user-authorization.service";
import { IdNameAsStringObject } from "../../../pb-screen/models/quick-view/id-name-as-string-object.interface";

declare  var jQuery:  any;


@Component({
    selector: "update-screens-modal",
    templateUrl: "./update-screen-authorization-modal.component.html",
})
export class UpdateScreenAuthorizationComponent extends SimpleModalComponent<void,void> implements OnInit, OnDestroy {

    @select("selectedAzureUsers") public selectedAzureUsers$: Observable<any[]>;
    @select("planningGroups") public planningGroups$: Observable<IdNameAsStringObject[]>;

    public selectedUsers: any[] = [];
    public modalType = ModalType;
    public selectedScreens :string[] = [];
    public usernames : string[];  
    public authorizationUsersSettings: UserAuthorizationViewModel[] = [];
    public loaderEnabled: boolean = false;
    public canAddPBToExistingTO: boolean = false;
    public destroy$ = new Subject();

    public screenList:any [] = [] ; 
    public allPlanningGroups: IdNameAsStringObject[] = [] ;
    public selectedPlanningGroups: string[] = [] ;

    constructor(private readonly sharedActions: SharedActions, 
        private readonly applicationUserService: ApplicationUserService , 
        public readonly toastr : ToastrService, 
        public readonly UserSettingsService: UserSettingsService ,
       private readonly modalManager: ModalManagerService
    ) {
        super();

    }
    ngOnInit(): void {
        this.screenList = ApplicationScreens;
        this.selectedScreens = [];
        this.loaderEnabled = true;
        this.selectedAzureUsers$.subscribe((data) => { 
            if (data && data.length > 0) {
                this.selectedUsers = data;
                this.usernames  = this.selectedUsers.map(x => {return x.objectId});
                var usernames = this.selectedUsers.map((x) => { return x.objectId }).join(",") ;
                if(usernames == "" || usernames == null) 
                {
                    this.toastr.warning("No Usernames found for selected users");
                    this.loaderEnabled = false;
                }
                else {
                    this.UserSettingsService.getOrCreateUserSettingByName("userAuthorization" , usernames).subscribe((result) => { 
                        this.loaderEnabled = false;
                        this.authorizationUsersSettings = [] ;  
                        result.forEach((item) => {  
                            let userAuthorizationValue = undefined;
                            if(item.value && item.value != "") { 
                                userAuthorizationValue = JSON.parse(item.value); 
                            }
                            else {
                                userAuthorizationValue = { screenAuthorizations: [], authorizedActions: []};

                            }
                            this.authorizationUsersSettings.push( { username: item.userId, authorization: userAuthorizationValue , settings: item });
                                               }) ; 
                        this.setModalData();
                    })
                }
            }
        }); 
        this.planningGroups$.subscribe((data) => {
            this.allPlanningGroups = data;
        });
    }
    public getSelectValue(user:any)
     {
       var appUser = this.authorizationUsersSettings.filter(x=> x.username == user.userId)[0] ; 
       if(appUser) 
            return appUser.authorization.actionAuthorizations.filter( a=> a.actionName == UserActions.canAddPBToExistingTO && a.authorized).length> 0 ? "Yes"  : "No"; 
            else return "No"; 


     }
    public setModalData() 
    {
        this.selectedUsers.forEach((item) => {
            item.screens = "";
            var userAuthorizedScreens = this.authorizationUsersSettings.filter((x) => { return x.username == item.objectId})[0].authorization.screenAuthorizations.filter((x) => { return x.authorized == true}).map((x) => { return x.screenName}); 
            if (userAuthorizedScreens != null && userAuthorizedScreens != undefined && userAuthorizedScreens.length > 0)
            {

                userAuthorizedScreens.forEach((screen) => { 
                    this.screenList.filter(s=> s.screenName == screen).forEach((s) => {
                        this.selectedScreens.push(s.screenName);
                        item.screens = s.screenCaption + "," +  item.screens; 
                    });
                });
                               
            } else {
                item.screens = ""; 
            }
            this.canAddPBToExistingTO = this.authorizationUsersSettings.filter((x) => { return x.username == item.objectId })[0].authorization.actionAuthorizations.filter(a => a.actionName == UserActions.canAddPBToExistingTO && a.authorized).length>0; 

            this.selectedPlanningGroups = this.authorizationUsersSettings.filter((x) => { return x.username == item.objectId })[0].authorization.planningGroupAuthorizations;
           
        })
    }
   
    public isScreenSelected(screenName){
        return this.selectedScreens.indexOf(screenName) > -1;

    }
    public selectScreen(screenName) 
    {
        let index = this.selectedScreens.indexOf(screenName);
        if(index == -1) {
            this.selectedScreens.push(screenName);
        } 
        else 
        {
            this.selectedScreens.splice(index,1);
        } 
    }

    public updateAction() 
    {
        
        var screens = this.selectedScreens.map((x) => { return { screenName: x, authorized: true}}); 

        this.selectedUsers.forEach((item) => {
            var userAuthorization = this.authorizationUsersSettings.filter((x) => { return x.username == item.objectId})[0]; 
            userAuthorization.authorization.screenAuthorizations = screens; 
            userAuthorization.authorization.actionAuthorizations = [{ actionName: UserActions.canAddPBToExistingTO, authorized: this.canAddPBToExistingTO}]; 
            userAuthorization.authorization.planningGroupAuthorizations = this.selectedPlanningGroups;
            
            userAuthorization.settings.value = JSON.stringify(userAuthorization.authorization);
            this.UserSettingsService.createOrUpdateUserSettings(userAuthorization.settings , item.userId).subscribe((result) => { 
                this.toastr.success("User settings updated successfully");
        }) });

        this.closeModal();
    }
   


    public async closeModal() {
        await this.close();
    }

    ngOnDestroy(): void {
        this.selectedScreens =[] ;
        this.authorizationUsersSettings = [] ; 
        this.destroy$.next();
        this.destroy$.complete();
    }


}
export class UserAuthorizationViewModel {
    username: string; 
    settings: UserSettings; 
    authorization: UserAuthorization;
}